/* GiftInOne Editor — optional local text contrast. No network or order dependencies. */
(function (root) {
  'use strict';
  if (root.GIOEditorV2AutoColor) return;
  function hex(value) { return /^#[a-f\d]{6}$/i.test(value || '') ? value.toLowerCase() : null; }
  function rgb(value) { var color=hex(value);return color?[parseInt(color.slice(1,3),16),parseInt(color.slice(3,5),16),parseInt(color.slice(5,7),16)]:null; }
  function linear(value) { value/=255;return value<=.04045?value/12.92:Math.pow((value+.055)/1.055,2.4); }
  function luminance(red,green,blue) { return .2126*linear(red)+.7152*linear(green)+.0722*linear(blue); }
  function contrast(a,b) { return (Math.max(a,b)+.05)/(Math.min(a,b)+.05); }
  function best(luma) { return contrast(luma,1)>contrast(luma,0)?'#ffffff':'#000000'; }
  function choose(options) {
    options=options||{};
    var existing=hex(options.currentFill),pixels=options.pixels,rect=options.rect,material=rgb(options.materialColor);
    try {
      if(!pixels||!rect||!pixels.data||!Number.isInteger(pixels.width)||!Number.isInteger(pixels.height)||pixels.width<1||pixels.height<1||
          pixels.data.length!==pixels.width*pixels.height*4||!['x','y','width','height'].every(function(key){return Number.isFinite(rect[key]);})||rect.width<=0||rect.height<=0)return existing;
      var w=pixels.width,h=pixels.height,data=pixels.data,mask=options.mask;
      if(mask&&mask.length!==data.length)return existing;
      var angle=Number(options.rotation)||0;if(!Number.isFinite(angle))return existing;
      var cosine=Math.cos(angle*Math.PI/180),sine=Math.sin(angle*Math.PI/180),cx=(rect.x+rect.width/2)*w,cy=(rect.y+rect.height/2)*h;
      // A bounded local grid follows the physical text box's rotation. This
      // avoids a whole-photo average and stays cheap for many message fields.
      var columns=Math.max(1,Math.min(32,Math.ceil(rect.width*w))),rows=Math.max(1,Math.min(32,Math.ceil(rect.height*h))),sum=0,count=0,unknown=0,visible=0;
      for(var row=0;row<rows;row++)for(var column=0;column<columns;column++){
        var dx=((column+.5)/columns-.5)*rect.width*w,dy=((row+.5)/rows-.5)*rect.height*h;
        var x=Math.floor(cx+dx*cosine-dy*sine),y=Math.floor(cy+dx*sine+dy*cosine);
        if(x<0||y<0||x>=w||y>=h)continue;
        var index=(y*w+x)*4;if(mask&&mask[index+3]<128)continue;
        visible++;var alpha=data[index+3]/255;
        // Missing material information is not white. Preserve the user's
        // existing ink when transparent material meaningfully affects the box.
        if(alpha<.98&&!material){unknown++;continue;}
        var under=material||[0,0,0],red=data[index]*alpha+under[0]*(1-alpha),green=data[index+1]*alpha+under[1]*(1-alpha),blue=data[index+2]*alpha+under[2]*(1-alpha);
        sum+=luminance(red,green,blue);count++;
      }
      if(!count||!visible||unknown/visible>.02)return existing;
      return best(sum/count);
    } catch (_) { return existing; }
  }
  root.GIOEditorV2AutoColor={version:'1.0.0',choose:choose,luminance:luminance,contrast:contrast};
}(window));
